import React from "react";
import { Row, Col, Card, Form, Input, Space, Image } from "antd";
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";
const { TextArea } = Input;

const Layout5 = ({ onChange, initialData }) => {
  const [form] = Form.useForm();
  const imageUrl = Form.useWatch("imageUrl", form);

  return (
    <Card
      style={{
        background: "#f9fafb",
        border: "2px dashed #1890ff",
      }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialData}
        onValuesChange={(_, allValues) => onChange(allValues)}
      >
        <Row gutter={32}>
          <Col span={10}>
            <Form.Item label="Image URL" name="imageUrl">
              <Input placeholder="Paste image URL" />
            </Form.Item>
            <div
              style={{
                width: "100%",
                border: "1px dashed #d9d9d9",
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#fff",
              }}
            >
              {imageUrl ? (
                <Image
                  src={imageUrl}
                  alt="Preview"
                  style={{
                    objectFit: "cover",
                  }}
                />
              ) : (
                <span style={{ color: "#999" }}>Image Preview</span>
              )}
            </div>
          </Col>
          <Col span={14}>
            {/* Small Title */}
            <Form.Item label="Small Title" name="smallTitle">
              <Input placeholder="About Us" />
            </Form.Item>
            {/* Main Title */}
            <Form.Item label="Main Title" name="mainTitle">
              <Input placeholder="We are crafting your unique business consulting ideas." />
            </Form.Item>
            {/* Dynamic Text Areas */}
            <Form.List name="descriptions" initialValue={[{}]}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field, index) => (
                    <div key={field.key}>
                      <Row gutter={12} align="middle">
                        <Col flex="auto">
                          <Form.Item
                            label={`Description ${index + 1}`}
                            name={[field.name, "text"]}
                            style={{ marginBottom: 0 }}
                          >
                            <TextArea rows={3} placeholder="Enter description text" />
                          </Form.Item>
                        </Col>
                        <Col>
                          <Space direction="vertical">
                            <PlusCircleOutlined
                              style={{ fontSize: 18, color: "#1890ff" }}
                              onClick={() => add()}
                            />
                            {fields.length > 1 && (
                              <DeleteOutlined
                                style={{ fontSize: 18, color: "red" }}
                                onClick={() => remove(field.name)}
                              />
                            )}
                          </Space>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default Layout5;